(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-hero-switch]').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const active = button.getAttribute('aria-checked') !== 'true';
        button.setAttribute('aria-checked', String(active));
        button.closest('.ms-hero').classList.toggle('is-switched-off', active);
      });
    });
    root.querySelectorAll('[data-bundles]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const form = section.querySelector('form');
      const submit = section.querySelector('.ms-buy');
      const sync = () => {
        const selected = form.querySelector('input[name="id"]:checked');
        section.querySelectorAll('.ms-bundle-card').forEach(card => card.classList.toggle('is-selected', !!card.querySelector('input:checked')));
        const ready = selected?.dataset.ready === 'true' && !!selected.value;
        submit.disabled = !ready;
        section.querySelector('[data-purchase-status]').hidden = ready;
      };
      section.querySelectorAll('.ms-bundle-card').forEach(card => {
        card.addEventListener('click', event => {
          const input = card.querySelector('input[type="radio"]');
          if (event.target === input) return;
          event.preventDefault();
          input.focus({preventScroll: true});
          input.checked = true;
          input.dispatchEvent(new Event('change', {bubbles: true}));
        });
      });
      form.addEventListener('change', sync);
      sync();
      form.addEventListener('submit', event => {
        const chosen = form.querySelector('input[name="id"]:checked');
        if (chosen?.dataset.ready !== 'true') { event.preventDefault(); return; }
        // Native product forms preserve Shopify checkout and wallet handling.
        submit.setAttribute('aria-busy', 'true');
      });
    });
    root.querySelectorAll('[data-cart-section]').forEach(cart => {
      if (cart.dataset.initialized) return;
      cart.dataset.initialized = 'true';
      const updateButton = cart.querySelector('[data-cart-update]');
      if (updateButton) updateButton.hidden = true;
      let busy = false;
      const update = async (item, quantity, focusTarget) => {
        if (busy) return;
        const key = item.dataset.cartItem;
        const error = cart.querySelector('[data-cart-error]');
        const controls = [...cart.querySelectorAll('button:not(:disabled), input:not(:disabled)')];
        busy = true;
        cart.setAttribute('aria-busy', 'true');
        error.hidden = true;
        controls.forEach(control => control.disabled = true);
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
            method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({id: key, quantity, sections: cart.dataset.cartSection, sections_url: location.pathname})
          });
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : cart.dataset.cartErrorMessage);
          const html = data.sections?.[cart.dataset.cartSection];
          const next = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
          if (!next) { location.assign((window.Shopify?.routes?.root || '/') + 'cart'); return; }
          cart.replaceWith(next);
          document.querySelectorAll('[data-cart-count]').forEach(count => count.textContent = data.item_count);
          init(next.parentElement);
          const updatedItem = [...next.querySelectorAll('[data-cart-item]')].find(row => row.dataset.cartItem === key);
          const focus = updatedItem?.querySelector(focusTarget) || next.querySelector('h1');
          focus?.focus({preventScroll: true});
          next.querySelector('[data-cart-status]').textContent = next.dataset.cartUpdatedMessage;
        } catch (failure) {
          controls.forEach(control => control.disabled = false);
          error.textContent = failure.message || cart.dataset.cartErrorMessage;
          error.hidden = false;
          if (updateButton) updateButton.hidden = false;
          cart.removeAttribute('aria-busy');
          busy = false;
        }
      };
      cart.querySelectorAll('[data-cart-item]').forEach(item => {
        const input = item.querySelector('[data-cart-quantity]');
        item.querySelectorAll('[data-quantity-step]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click', () => {
            if (busy || !input.reportValidity()) return;
            const quantity = Math.max(0, Number(input.value) + Number(button.dataset.quantityStep));
            update(item, quantity, '[data-quantity-step="' + button.dataset.quantityStep + '"]');
          });
        });
        input.addEventListener('change', () => {
          if (input.reportValidity()) update(item, Number(input.value), '[data-cart-quantity]');
        });
        item.querySelector('[data-cart-remove]').addEventListener('click', event => {
          event.preventDefault();
          update(item, 0, '[data-cart-quantity]');
        });
      });
      // A founder spot only belongs next to a reservation, once per cart.
      const founderFix = cart.querySelector('[data-founder-fix]');
      if (founderFix) update({dataset: {cartItem: founderFix.dataset.cartFounder}}, Number(founderFix.dataset.founderFix), 'h1');
    });
    root.querySelectorAll('[data-countdown]').forEach(timer => {
      if (timer.dataset.initialized) return;
      timer.dataset.initialized = 'true';
      const tick = () => {
        const seconds = Math.max(0, Math.floor((new Date(timer.dataset.countdown).getTime() - Date.now()) / 1000));
        if (!Number.isFinite(seconds)) { timer.hidden = true; return; }
        const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
        timer.querySelectorAll('[data-time]').forEach((el, i) => el.textContent = String(values[i]).padStart(2, '0'));
      };
      tick(); const interval = setInterval(() => {if (!timer.isConnected) clearInterval(interval); else tick();}, 1000);
    });
    root.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (gallery.dataset.initialized) return;
      gallery.dataset.initialized = 'true';
      const track = gallery.querySelector('.ms-product-slides');
      const slides = [...track.children];
      const thumbs = [...gallery.querySelectorAll('[data-slide-index]')];
      const count = gallery.querySelector('[data-gallery-current]');
      const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      let index = 0;
      const show = next => {
        const target = (next + slides.length) % slides.length;
        track.scrollTo({left: track.clientWidth * target, behavior: motion()});
      };
      const sync = () => {
        const next = Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth));
        if (next !== index) slides[index].querySelectorAll('video').forEach(video => video.pause());
        index = next;
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
        if (count) count.textContent = String(index + 1).padStart(2, '0');
      };
      let frame;
      track.addEventListener('scroll', () => {cancelAnimationFrame(frame);frame = requestAnimationFrame(sync);}, {passive:true});
      thumbs.forEach(button => button.addEventListener('click', () => show(Number(button.dataset.slideIndex))));
      gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(index - 1));
      gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(index + 1));
      track.addEventListener('keydown', event => {
        if (event.target.closest('video,iframe,model-viewer')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();show(index + (event.key === 'ArrowRight' ? 1 : -1));}
      });
      new ResizeObserver(() => { if (gallery.isConnected) track.scrollTo({left: track.clientWidth * index, behavior:'instant'}); }).observe(track);
      gallery.addEventListener('ms:select-media', event => {
        const next = slides.findIndex(slide => slide.dataset.mediaId === String(event.detail));
        if (next !== -1) show(next);
      });
      const initialMedia = slides.findIndex(slide => slide.dataset.mediaId === gallery.dataset.initialMedia);
      if (initialMedia >= 0) {
        index = initialMedia;
        track.scrollTo({left: track.clientWidth * index, behavior:'instant'});
        sync();
      }
      const dialog = gallery.querySelector('dialog');
      if (!dialog) return; // Empty media slots have no image to magnify.
      const zoomImage = dialog.querySelector('[data-zoom-image]');
      const canvas = dialog.querySelector('.ms-zoom-canvas');
      let opener;
      let oldOverflow;
      gallery.querySelectorAll('[data-zoom-src]').forEach(button => button.addEventListener('click', () => {
        opener = button;
        index = slides.indexOf(button.closest('.ms-media-slide'));
        track.scrollTo({left: track.clientWidth * index, behavior:'instant'});
        zoomImage.src = button.dataset.zoomSrc;
        zoomImage.alt = button.querySelector('img').alt;
        canvas.classList.remove('is-zoomed');
        oldOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        dialog.showModal();
      }));
      const toggleZoom = () => canvas.classList.toggle('is-zoomed');
      canvas.addEventListener('click', toggleZoom);
      canvas.addEventListener('keydown', event => {if (event.key === 'Enter' || event.key === ' ') {event.preventDefault();toggleZoom();}});
      dialog.querySelector('.ms-zoom-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {if (event.target === dialog) dialog.close();});
      dialog.addEventListener('close', () => {document.documentElement.style.overflow = oldOverflow || '';opener?.focus({preventScroll:true});track.scrollTo({left:track.clientWidth * index,behavior:'instant'});});
      sync();
    });
    root.querySelectorAll('[data-pdp]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const form = section.querySelector('form');
      const button = form.querySelector('[data-pdp-buy]');
      const sync = (updateUrl = false) => {
        const radio = form.querySelector('input[name="ms_package"]:checked');
        if (!radio) return;
        const variantInput = form.querySelector('[data-pdp-variant]');
        if (variantInput.value !== radio.value) {variantInput.value = radio.value;variantInput.dispatchEvent(new Event('change', {bubbles:true}));}
        const ready = radio.dataset.ready === 'true';
        form.querySelector('[data-pdp-deposit]').textContent = radio.dataset.deposit;
        form.querySelector('[data-pdp-balance]').textContent = radio.dataset.balance;
        button.disabled = !ready;
        form.querySelector('[data-pdp-unavailable]').hidden = ready;
        section.querySelectorAll('.ms-pdp-package').forEach(label => label.classList.toggle('is-selected', label.contains(radio)));
        if (updateUrl) {const url = new URL(location.href);url.searchParams.set('variant',radio.dataset.targetVariant);history.replaceState({},'',url);}
      };
      section.querySelectorAll('.ms-pdp-package').forEach(label => label.addEventListener('click', event => {
        const radio = label.querySelector('input');
        if (event.target === radio) return;
        event.preventDefault();radio.checked = true;radio.focus({preventScroll:true});radio.dispatchEvent(new Event('change', {bubbles:true}));
      }));
      form.addEventListener('change', event => {if (event.target.name === 'ms_package') sync(true);});
      form.addEventListener('submit', event => {if (button.disabled) event.preventDefault();else button.setAttribute('aria-busy','true');});
      sync();
    });
    root.querySelectorAll('[data-pyjama]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const variants = JSON.parse(section.querySelector('[data-pyjama-data]').textContent);
      const select = section.querySelector('[data-pyjama-variant]');
      const groups = [...section.querySelectorAll('[data-option-index]')];
      const initial = variants.find(variant => String(variant.id) === select.value);
      groups.forEach((group, i) => {const choices = [...group.querySelectorAll('input')];const selected = choices.find(input => input.value === initial?.options[i]) || choices[0];if (selected) selected.checked = true;});
      const sync = (updateUrl = false) => {
        const options = groups.map(group => group.querySelector('input:checked')?.value);
        const variant = variants.find(item => item.options.every((value,i) => value === options[i]));
        select.value = variant ? String(variant.id) : '';
        const buy = section.querySelector('[data-pyjama-buy]');
        if (buy) buy.disabled = !variant?.available;
        if (variant) {
          section.querySelector('[data-pyjama-price]').textContent = variant.price;
          if (updateUrl) {const url = new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);}
          if (updateUrl && variant.mediaId) section.querySelector('[data-gallery]')?.dispatchEvent(new CustomEvent('ms:select-media',{detail:variant.mediaId}));
        }
      };
      section.querySelector('[data-pyjama-options]').hidden = false;
      section.querySelector('[data-pyjama-native]').hidden = true;
      groups.forEach(group => group.addEventListener('change', () => sync(true)));
      section.querySelector('form').addEventListener('submit', event => {const selected = variants.find(variant => String(variant.id) === select.value);if (!selected?.available || section.dataset.purchaseReady !== 'true') event.preventDefault();});
      sync();
    });
    root.querySelectorAll('[data-variant-select]').forEach(select => {
      if (select.dataset.initialized) return;
      select.dataset.initialized = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const form = select.closest('form');
        const price = form.querySelector('[data-variant-price]');
        if (price) price.textContent = option.dataset.price;
        const button = form.querySelector('[type="submit"]');
        if (button) button.disabled = option.dataset.available !== 'true';
      });
    });
  };
  const menu = document.querySelector('.ms-menu-toggle');
  const nav = document.querySelector('#ms-mobile-nav');
  const closeMenu = () => { if (!menu || !nav) return; menu.setAttribute('aria-expanded', 'false'); nav.hidden = true; };
  menu?.addEventListener('click', () => {const expanded = menu.getAttribute('aria-expanded') === 'true'; menu.setAttribute('aria-expanded', String(!expanded)); nav.hidden = expanded;});
  nav?.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));
  document.addEventListener('keydown', e => {if (e.key === 'Escape' && nav && !nav.hidden) {closeMenu(); menu.focus();}});
  if (matchMedia('(hover: hover) and (prefers-reduced-motion: no-preference)').matches) {
    const hero = document.querySelector('.ms-hero');
    const visual = hero?.querySelector('[data-tilt]');
    hero?.addEventListener('pointermove', e => {if(!visual)return;const r=hero.getBoundingClientRect();visual.style.transform=`perspective(1200px) rotateY(${(e.clientX-r.left-r.width/2)/r.width*5}deg) rotateX(${-(e.clientY-r.top-r.height/2)/r.height*3}deg)`;});
    hero?.addEventListener('pointerleave',()=>{if(visual)visual.style.transform='none';});
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
